var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25C17.93 1.25 22.75 6.07 22.75 12C22.75 17.93 17.93 22.75 12 22.75ZM12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 6.9 17.1 2.75 12 2.75Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.17035 15.5794C8.98035 15.5794 8.79035 15.5094 8.64035 15.3594C8.35035 15.0694 8.35035 14.5894 8.64035 14.2994L14.3004 8.63938C14.5904 8.34938 15.0704 8.34938 15.3604 8.63938C15.6504 8.92937 15.6504 9.40937 15.3604 9.69937L9.70035 15.3594C9.56035 15.5094 9.36035 15.5794 9.17035 15.5794Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8304 15.5794C14.6404 15.5794 14.4504 15.5094 14.3004 15.3594L8.64035 9.69937C8.35035 9.40937 8.35035 8.92937 8.64035 8.63938C8.93035 8.34938 9.41035 8.34938 9.70035 8.63938L15.3604 14.2994C15.6504 14.5894 15.6504 15.0694 15.3604 15.3594C15.2104 15.5094 15.0204 15.5794 14.8304 15.5794Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircle);
export default __webpack_public_path__ + "static/media/close-circle.1dc0b070512c1e9b3d21c2546802d5e7.svg";
export { ForwardRef as ReactComponent };